$(function () {
  $('.owl-carousel-bestsellers').owlCarousel({
    loop: false,
    margin: 15,
    lazyLoad: true,
    responsiveClass: true,
    autoplayHoverPause: true,
    dots: false,
    responsive: {
      0: {
        items: 2,
        nav: true,
        dots: false,
      },
      600: {
        items: 4,
        nav: true,
        autoplay: false,
      },
      1000: {
        items: 5,
        nav: true,
        autoplay: false,
        loop: false,
      },
    },
  });
});

$(document).ready(function () {
  function getParameterByName(name) {
    const url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  const selectedCategory = getParameterByName('category');

  if (selectedCategory) {
    $('.sc-bestssellers .col-md-12').hide();

    $('.sc-bestssellers .title').each(function () {
      const sectionTitle = $(this).text().trim();

      if (sectionTitle === selectedCategory) {
        $(this).closest('.col-md-12').show();
        $(this).closest('.col-md-12').next('.col-md-12').show();
      }
    });
  }
});
